import React from "react";

export default function RedAsterisk() {
    return <span className="color-text--error paddingleft-sm">*</span>;
}
